import { useState, useEffect } from "react";
import MembershipRequests from "./MembershipRequest";
import MembershipPlans from "./MembershipPlan";
import MembersList from "./Members";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function Membership() {
  const [tab, setTab] = useState("members");
  const navigate = useNavigate();
  

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Membership Management</h2>

      <button onClick={() => navigate(-1)} className="mb-4 px-4 py-2 bg-gray-300 rounded hover:bg-gray-400">
        ← Back
      </button>
      
      {/* Tabs */}
      <div className="flex space-x-4 mb-6">
        <button onClick={() => setTab("members")} className={`px-4 py-2 rounded ${tab === "members" ? "bg-blue-600 text-white" : "bg-gray-200"}`}>
          View Members
        </button>
        <button onClick={() => setTab("requests")} className={`px-4 py-2 rounded ${tab === "requests" ? "bg-blue-600 text-white" : "bg-gray-200"}`}>
          Membership Requests
        </button>
        <button onClick={() => setTab("plans")} className={`px-4 py-2 rounded ${tab === "plans" ? "bg-blue-600 text-white" : "bg-gray-200"}`}>
          Membership Plans
        </button>
      </div>

      {/* Tab Content */}
      {tab === "members" && <MembersList />}
      {tab === "requests" && <MembershipRequests />}
      {tab === "plans" && <MembershipPlans />}


    </div>
  );
}
